export const SUPERMETRICS = 'supermetrics'

export const PLATFORM = {
  ADTRACTION: 'adtraction',
  HUBSPOT: 'hubspot',
  KLAVIYO: 'klaviyo',
  ADOBE_ANALYTICS: 'adobe_analytics',
  SPOTIFY_ADS: 'spotify_ads',
  REDDIT_ADS: 'reddit_ads',
  RTB_HOUSE: 'rtb_house',
  WOOCOMMERCE: 'woocommerce',
  CJ_AFFILIATE: 'cj_affiliate',
  TRADEDOUBLER: 'tradedoubler',
  GOOGLE_CAMPAIGN_MANAGER360: 'google_campaign_manager360',
  PARTNERIZE: 'partnerize',
  STACKADAPT: 'stackadapt',
  SHOPIFY_SUPERMETRICS: 'shopify_sm',
  X_ADS: 'x_ads',
  STRIPE: 'stripe',
  QUANTCAST: 'quantcast'
} as const

export type SupermetricsPlatform = (typeof PLATFORM)[keyof typeof PLATFORM]

export const PLATFORM_TO_DS_ID = {
  [PLATFORM.ADTRACTION]: 'ADTRA',
  [PLATFORM.HUBSPOT]: 'HS',
  [PLATFORM.KLAVIYO]: 'KLAV',
  [PLATFORM.ADOBE_ANALYTICS]: 'ASC',
  [PLATFORM.SPOTIFY_ADS]: 'SPA',
  [PLATFORM.REDDIT_ADS]: 'RDA',
  [PLATFORM.RTB_HOUSE]: 'RTBH',
  [PLATFORM.WOOCOMMERCE]: 'WOOC',
  [PLATFORM.CJ_AFFILIATE]: 'CJA',
  [PLATFORM.TRADEDOUBLER]: 'TRD',
  [PLATFORM.GOOGLE_CAMPAIGN_MANAGER360]: 'DFA',
  [PLATFORM.PARTNERIZE]: 'PART',
  [PLATFORM.STACKADAPT]: 'STAC',
  [PLATFORM.SHOPIFY_SUPERMETRICS]: 'SHP',
  [PLATFORM.X_ADS]: 'TA',
  [PLATFORM.STRIPE]: 'ST',
  [PLATFORM.QUANTCAST]: 'QUCA'
} as const

export const ERROR_CODES = {
  ACCESS_TOKEN_INVALID: 'ACCESS_TOKEN_INVALID'
} as const
